export default __webpack_public_path__ + "static/media/Group 106.5ffc0ad3.png";